import { APIGatewayProxyEvent } from 'aws-lambda';

export function getHeader(event: APIGatewayProxyEvent, key: string) {
  if (!event || !event.headers || !key) return undefined;
  // AWS API gateway makes it lowercase, not sure why 😕
  // where as serverless-offline keep it in the original case
  return event.headers[key] || event.headers[key.toUpperCase()] || event.headers[key.toLowerCase()];
}
